import { Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import PageBaseModule from '@/store/page';
import { getList } from '@/api/crud';
import { CatalogKind, catalogPath, errorMessage } from '@/api/analysisCalculator';

const escapeText = (value: string) => value.replace(/[&<>"']/g, char => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char] || char));

@Module({ dynamic: true, store, name: 'analysisCalculator', namespaced: true })
class CatalogModule extends PageBaseModule {
    constructor(module: CatalogModule) { super(module); }
    kind: CatalogKind = 'categories';
    query = '';
    category = '';
    active = '';
    loading = false;
    error = '';
    requestVersion = 0;

    @Mutation configure(kind: CatalogKind) {
        this.kind = kind;
        this.query = '';
        this.category = '';
        this.active = '';
        this.pageSettings.pageCurrent = 1;
        this.pageSettings.sort = {};
        this.pageSettings.table = {};
        this.pageSettings.routeName = `analysis-calculator-${kind}-edit`;
        this.pageSettings.routeParam = 'id';
        this.pageSettings.actionPagination = 'analysisCalculator/updatePage';
        this.pageSettings.actionPageAmountItems = 'analysisCalculator/updatePageAmountItems';
        this.requestVersion++;
    }

    @Mutation setFilters(data: { query: string; category: string; active: string }) {
        Object.assign(this, data);
        this.pageSettings.pageCurrent = 1;
    }

    @Mutation startRequest() { this.requestVersion++; this.loading = true; this.error = ''; }
    @Mutation finishRequest(error: string) { this.loading = false; this.error = error; }

    @Action({ rawError: true }) async getList() {
        this.context.commit('startRequest');
        const version = this.requestVersion;
        const filters = [['search', this.query], ['category', this.category], ['isActive', this.active]]
            .filter(([, value]) => value !== '')
            .map(([id, value], index) => `filters[${index}][id]=${id}&filters[${index}][value]=${encodeURIComponent(value)}`).join('&');
        try {
            const result = await getList(catalogPath(this.kind), { page: this.pageSettings.pageCurrent, items: this.pageSettings.pageAmountItems }, await this.getSortForRequest(), filters);
            if (version !== this.requestVersion) return;
            // The shared table renders HTML; catalog labels must remain plain text.
            result.table.rows = Object.values(result.table.rows).map((row: any) => Object.fromEntries(Object.entries(row).map(([key, value]) => [key, typeof value === 'string' ? escapeText(value) : value])));
            await this.context.dispatch('setList', result.table);
            this.context.commit('finishRequest', '');
        } catch (error) {
            if (version === this.requestVersion) this.context.commit('finishRequest', errorMessage(error));
        }
    }
}

export default getModule(CatalogModule);
